import { useTran } from "@/hooks";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

// The outline Badge variant bakes in dark:border-slate-700, which would
// otherwise win over an unscoped border color in dark mode — so both the
// border and text need explicit dark: counterparts, not just a light shade.
const INACTIVE_BADGE_CLASSNAME =
  "h-4 rounded-md border-amber-500 px-1 py-0 text-xs font-medium text-amber-700 dark:border-amber-500/70 dark:text-amber-400";

const getInactiveYear = (inactiveDate) => {
  if (!inactiveDate) return null;
  const date =
    inactiveDate instanceof Date ? inactiveDate : new Date(inactiveDate);
  const year = date.getFullYear();
  return Number.isFinite(year) ? year : null;
};

const getInactiveStatusLabel = (t, { inactiveByChildren, year }) => {
  // Derived-inactive parents should not show a badge in the UI. Some callers
  // only pass status + inactiveDate, so a missing year is treated the same.
  if (inactiveByChildren || !year) return null;
  return t("Inactive since {{year}}", { year });
};

// Active is the default state and needs no tag; only Inactive is called out,
// in one shared style, wherever a unit's status is shown (tree, detail panel).
const OrgStatusTag = ({
  status,
  className,
  inactiveDate = null,
  inactiveByChildren = false,
}) => {
  const { t } = useTran();
  if ((status || "active") !== "inactive") return null;

  const year = getInactiveYear(inactiveDate);
  const label = getInactiveStatusLabel(t, { inactiveByChildren, year });

  if (!label) return null;

  return (
    <Badge
      variant="outline"
      className={cn(INACTIVE_BADGE_CLASSNAME, className)}
    >
      {label}
    </Badge>
  );
};

export default OrgStatusTag;
